import type { NativeStackNavigationOptions } from '@react-navigation/native-stack';
import { useNavigation } from 'expo-router';
import { useLayoutEffect } from 'react';
import { useIsFocused } from './useIsFocused';

export function useSetHeader(options: NativeStackNavigationOptions) {
  const navigation = useNavigation();
  const isFocused = useIsFocused();

  useLayoutEffect(() => {
    if (isFocused) {
      navigation.setOptions(options);
    }
  }, [isFocused, navigation, options]);
}
